import { render, staticRenderFns } from "./qrSkype.vue?vue&type=template&id=78bd731e&scoped=true"
import script from "./qrSkype.vue?vue&type=script&lang=js"
export * from "./qrSkype.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bd731e",
  null
  
)

export default component.exports